export const MenuHome = ({ size }: { size: number }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 36 36"
    width={size}
    height={size}
  >
    <path
      d="M33.12,21.69a3,3,0,0,0-.67.09l-4.06-6.46a2.89,2.89,0,1,0-5.21-1.69s0,.08,0,.12L20.13,15a2.85,2.85,0,0,0-2.13-1,2.79,2.79,0,0,0-1.54.46l-3.57-3a3,3,0,0,0,.18-1A2.85,2.85,0,0,0,8.71,8.07L5.56,5.45a3.05,3.05,0,0,0,.2-1,2.88,2.88,0,1,0-2.88,2.9A2.84,2.84,0,0,0,4.4,6.87L7.52,9.48a2.9,2.9,0,0,0,2.67,4A2.85,2.85,0,0,0,11.74,13l3.57,3a2.83,2.83,0,0,0-.19,1,2.89,2.89,0,0,0,1.47,2.52l-.52,3.88a2.9,2.9,0,0,0,.46,5.76,2.84,2.84,0,0,0,1.74-.6l3.43,2.29a3.17,3.17,0,0,0-.11.76,2.88,2.88,0,1,0,5.76,0,2.93,2.93,0,0,0-.18-1L31.55,27a2.83,2.83,0,0,0,1.57.48,2.91,2.91,0,0,0,0-5.82Zm-9.27-6.22a2.82,2.82,0,0,0,2.21,1.07,2.71,2.71,0,0,0,.85-.15l4,6.37a3,3,0,0,0-.66,1.84,2.84,2.84,0,0,0,.18,1L26,29.16a2.82,2.82,0,0,0-1.57-.47,2.89,2.89,0,0,0-1.75.6L19.3,27a3.33,3.33,0,0,0,.11-.77,2.89,2.89,0,0,0-1.54-2.56l.51-3.83A2.89,2.89,0,0,0,20.88,17c0-.08,0-.16,0-.24Z"
      fill="currentcolor"
    />
  </svg>
)
